<template>
  <div class="Header-com">
    <navBar @handleClose ="()=>$refs.appdown.dialogDown = !$refs.appdown.dialogDown">
      <template slot="logoshow">
        <div class="logoImg" @click="handleGoRouter('/home')">
          <img src="../common/img/11ic-logo.svg" alt width="100%" height="100%"/>
        </div>
      </template>
      <template slot="btnlogo">
        <div class="tech-right">
          <!--登陆成功-->
          <div class="login-after" v-show="isLogin">
            <div class="combo-icon">
              <span class="register-btn">VIP{{vipLevel || 0}}</span>
            </div>  
            <div class="name">
              <span class="userAccount">{{userAccount}}</span>
              <div class="draw-down">
                <img src="./img/top_more.png" alt height="8px" width="12px"/>
                <drawBox @getCookie="getCookie" class="drappage"/>
              </div>
            </div>
            <div class="symbol">
              <span class="xinfeng_span" @click="handleGoRouter('/mine/inEmail')">
                <span class="xinfeng"></span>
                <el-badge :value="inEmailNoRead" :max="99" v-if="inEmailNoRead > 0" class="badage"/>
              </span>
              <span class="amount" @click ="$refs.wallet.iswallet = !$refs.wallet.iswallet">{{accountBalance}} ₹</span>
            </div>
            <div class="combo-icon">
              <span class="register-btn" @click="handleGoRouter('/mine')">{{ $t('mine.capital.deposit') }}</span>
            </div>  
          </div>
          <!-- 未登录 -->
          <div class="combo-icon" v-show="!isLogin">
            <appDownload2 ref="appdown2"/>
            <span class="deposit-btn _btn" @click="setshowloginfloat2(true)">{{$t('header.login')}}</span>
            <span class="register-btn _btn" @click="setshowloginfloat(true)">{{$t('header.register')}}</span>
            <languages />
          </div>
        </div>
      </template>
    </navBar>
    <!-- 下载弹窗 -->
    <appDownload ref="appdown"/>
    <walletlialog ref="wallet"/>
  </div>
</template>

<script>
import navBar from './navBar'
import drawBox from './drawBox'
import { common, commonApi } from "@/common/index";
import { mapState, mapMutations, mapActions } from "vuex";
import QRCode from "qrcodejs2";
import appDownload from "../common/appDownload.vue";
import appDownload2 from "../common/appDownload2.vue";
import walletlialog from "../common/walletlialog";
import languages from '../common/languages.vue'
import { WEBSITE, HOTEL } from "../../assets/js/domian";
import 'vuetify/dist/vuetify.min.css'
export default {
  name: "Header",
  computed: {
    ...mapState({
      jin_sha_global_login_state: (state) => state.jin_sha_global_login_state, // 是否在首页
      UUID: (state) => state.UUID,
      appJump: (state) => state.linkList.appJump,
      isLogin: (state) => state.isLogin,
      vipLevel: state => state.userInfo.userInfo.level,
      accountBalance: (state) => state.userInfo.assetsInfoMap.accountBalance,
      userAccount: (state) => state.userInfo.userInfo.userAccount,
      inEmailNoRead: state => state.inEmailNoRead
    }),
  },
  components: { QRCode,appDownload,navBar,drawBox,walletlialog,languages,appDownload2},
  watch: {
    jin_sha_global_login_state() {
      if (!this.jin_sha_global_login_state) {
        this.isShowLogin = true;
      } else { this.isShowLogin = false;}
    },
  },
  data() {
    return {
      yhPcLiveChatList:'',
      yhPcWhatsappList:'',
      username: "",
      password: "",
      vrifyCode: "",
      isReady: true,
      securityCodeSrc: "",
      config: {
        width: 90, // 设置宽度
        height: 90, // 设置高度
        text: "",
      },
    };
  },
  methods: {
    ...mapMutations(["setshowloginfloat","setshowloginfloat2","setTableVisible",]),
    ...mapActions(["checkLogin", "IS_LOGIN_FOCUS", "getFirstInfo"]),
    handleGoRouter(url){
      this.$router.push({ path:url})
    },
    qrcode() {
      this.$set(this.config, "text", this.appJump);
      let qrcode = new QRCode("qrcode", this.config);
    },
    handleScroll() {
      // 改变元素#searchBar的top值
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (!this.jin_sha_global_login_state) {
        this.isShowLogin = true;
        return;
      }

      if (scrollTop < 557) {
        this.isShowLogin = false;
      } else {
        this.isShowLogin = true;
      }
    },
    getVifyCode() {  // 随机产生验证码
      this.vrifyCode = "";
      let randomStr = common.randomRange(16);
      let timer = Math.floor(Date.now() / 1000);
      this.securityCodeSrc =
        this.$urls.USER.REGISTERCODE + `?timestamp=${timer}` + randomStr;
      this.timestamp = timer + randomStr;
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.username = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            // 解密
            let MD5password = common.Decrypt(arr2[1]);
            this.password = MD5password;
          }
        }
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
    fetchImg() {
      let imgCodes = ['pcLiveChat','pcWhatsApp'].join(',')
      commonApi.HOMEBEFORE.fetchImgs(imgCodes)
      .then((data)=>{
        this.yhPcLiveChatList = data.pcLiveChat;
        this.yhPcWhatsappList = data.pcWhatsApp;
      })
    },
  },
  mounted() {
    this.fetchImg();
    this.getCookie();
    if (!this.jin_sha_global_login_state) { // 是否需要显示登录
      this.isShowLogin = true;
    }

    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    this.getVifyCode();
  },
};
</script>

<style scoped lang="scss">
@import "../../style/mixins";
.Header-com {
  z-index:2;
  position: relative;
  .tech-right {
    // position: absolute;
    right:0;
    .login-after {
      min-width:401px;
      display: flex;
      justify-content: flex-end;
      font-family: Roboto-Black;;
      font-size: 14px;
      color: #fff;
      font-weight: 550;
      .name{
        display:flex;
        cursor: pointer;
        &:hover{.draw-down .drappage{ display:block }}
        .draw-down{
          width:30px;
          img{ text-align: center; }
          position: relative;
          .drappage{ display:none }
        }
        .userAccount{
          margin-right:8px;
          &::before{
            content:'';
            width: 20px;
            height: 23px;
            background-image:url('./img/pople.png');
            margin-right:8px;
            @include bg;
          }
        }
      }
      .symbol{
        margin: 0 20px 0 12px;
        cursor: pointer;
        .xinfeng_span{
          position: relative;
          .xinfeng{
            background-image:url('./img/top_message.png');
            width: 21px;
            height: 25px;
            @include bg;
          }
        }
        .amount{ margin-left:20px;}
      }
    }
    .combo-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      .register-btn,._btn {
        cursor: pointer;
        // background-color: #fff;
        border: 1px solid rgba(243, 184, 103, 1);
        color: rgba(243, 184, 103, 1);
        border-radius: 30px;
        padding: 6px 24px;
        font-family: Roboto-Black;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        display: block;
        line-height: 1;
        letter-spacing: 0px;
        font-weight: 550;
        margin-right:15px;
      }
      .deposit-btn{ margin-right:15px;}
      .register-btn{
        // background-color: #13aef8;
        background-color: rgba(243, 184, 103, 1);
        color: black;
      }
    }
  }
  .logoImg{
    // width:98px; 
    position: absolute;
    left:50%;
    transform: translateX(-50%);
    img { height:40px; cursor: pointer; vertical-align: middle;}
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build902/components/Header/Header.vue